// src/crm/compose/EmailEditor.jsx
// ------------------------------
// Rich-text editor for the CRM compose screen, built on react-quill-new (Quill 2).
// Same public contract as before -- { value, onChange } where onChange receives
// the body HTML -- so ComposeView is unchanged. emailHtml.buildEmailDocument still
// sanitises + wraps this HTML into the branded, email-safe document.
//
// Email-safety: Quill applies alignment/colour/size as CSS *classes* by default,
// but email clients ignore <style>/classes -- so we register Quill's STYLE
// attributors (once, at module load) to emit INLINE styles instead.

import ReactQuill from "react-quill-new";
import "quill/dist/quill.snow.css";
import { logger } from "../../utils/logger";

const Quill = ReactQuill.Quill;
if (Quill?.import) {
  try {
    Quill.register(Quill.import("attributors/style/align"), true);
    Quill.register(Quill.import("attributors/style/color"), true);
    Quill.register(Quill.import("attributors/style/background"), true);
    Quill.register(Quill.import("attributors/style/size"), true);
  } catch (e) {
    // Best-effort: if the attributors aren't available the editor still works,
    // it just falls back to class-based formatting for align/colour.
    logger.warn("Quill style attributors not registered:", e);
  }
}

const MODULES = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ color: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link"],
    ["clean"],
  ],
};

const FORMATS = ["header", "bold", "italic", "underline", "color", "list", "align", "link"];

function EmailEditor({ value = "", onChange, readOnly = false }) {
  return (
    <div className="crm-quill">
      {/* Quill's editor area is short by default; give it room. Scoped by .crm-quill. */}
      <style>{".crm-quill .ql-editor{min-height:220px;font-size:14px;line-height:1.6}"}</style>
      <ReactQuill
        theme="snow"
        value={value}
        readOnly={readOnly}
        onChange={(html) => {
          if (onChange) onChange(html);
        }}
        // Read-only cards drop the toolbar (nothing to click); editing shows it.
        modules={readOnly ? { toolbar: false } : MODULES}
        formats={FORMATS}
        placeholder="Write your message..."
      />
    </div>
  );
}

export { EmailEditor };
